import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { ChevronUp } from 'lucide-react';

interface SimilarPostItemProps {
  post: {
    id: string;
    title: string;
    slug: string;
    status: string;
    score: number;
  };
}

const statusVariantMap: Record<string, 'open' | 'review' | 'planned' | 'progress' | 'complete' | 'closed'> = {
  open: 'open',
  under_review: 'review',
  planned: 'planned',
  in_progress: 'progress',
  completed: 'complete',
  closed: 'closed',
};

const statusLabelMap: Record<string, string> = {
  open: 'Open',
  under_review: 'Under Review',
  planned: 'Planned',
  in_progress: 'In Progress',
  completed: 'Completed',
  closed: 'Closed',
};

export function SimilarPostItem({ post }: SimilarPostItemProps) {
  const statusVariant = statusVariantMap[post.status] || 'open';
  const statusLabel = statusLabelMap[post.status] || post.status;

  return (
    <Link
      to={`/posts/${post.slug}`}
      className="block p-3 rounded-lg border border-border bg-card hover:bg-accent/50 transition-colors"
    >
      <p className="text-sm font-medium text-foreground line-clamp-2 mb-2">
        {post.title}
      </p>
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <span className="flex items-center gap-0.5">
          <ChevronUp className="h-3 w-3" />
          {post.score}
        </span>
        <span className="text-muted-foreground/50">·</span>
        <Badge variant={statusVariant} className="text-[10px] py-0">
          {statusLabel}
        </Badge>
      </div>
    </Link>
  );
}
